// extracted by mini-css-extract-plugin
module.exports = {"iframeComponent":"IFrame_iframeComponent__IG5ho"};